// import React, { useEffect, useState, useRef } from "react";
// import { Line } from "@ant-design/plots";
// import styled from "@emotion/styled";
// import COLORS from "common/Colors";
// import { Spin, Progress, List } from "antd";
// import { get, find, map, size, filter, reduce, result, isEmpty } from "lodash";
// import {
//   MONTH_LIST,
//   CHECKIN_REPORT_FILTER_TYPES,
//   STATUS_CODE,
// } from "common/Constants";
// import {
//   addDaysinDate,
//   dateInDetail,
//   getMonthDateRange,
//   getKenyanDateTime,
//   addMonthinDate,
//   getMySqlDate,
//   momentDate,
//   getinitialdate,
// } from "utils/Date";
// import {
//   Row,
//   Col,
//   Table,
//   Select,
//   DatePicker,
//   Space,
//   Form,
//   Tooltip,
//   Modal,
//   message,
//   Button,
// } from "antd";
// import moment from "moment";
// import { DEVICE } from "common/Device";
// import { padding } from "@mui/system";
// import { CALL_API } from "common/API";
// import { CSVLink } from "react-csv";
// import {
//   getUserInfo,
//   getUserList,
//   getIsCheckedIn,
//   getClientid,
//   getMenuList,
//   getUserRoleId,
// } from "redux/selectors";
// import { connect } from "react-redux";
// import { ButtonOutlined } from "reusableComponent/UIButtons";

// const StyledTitle = styled.div`
//   font-size: 1rem;
//   font-weight: 600;
//   color: #141414;
//   margin-bottom: 10px;
// `;

// const StyledChartContainer = styled.div`
//   // min-height: 280px;
//   padding: 20px;
//   box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
//   border-radius: 5px;
//   // margin-bottom: 25px;
//   height: 100%;

//   .list-item {
//     width: 100%;
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     @media (max-width: 426px) {
//       font-size: 10px;
//     }
//   }
//   .name-title {
//     font-size: 14px;
//     padding-bottom: 15px;
//   }
//   .dash-line {
//     width: 60%;
//     border-bottom: 1px dashed #a8a8a8;
//     @media (max-width: 321px) {
//       width: 2%;
//     }
//   }
//   .title {
//     padding: 10px;
//     font-weight: bold;
//   }
//   .report_list {
//     height: calc(100% - 20px);
//     overflow: auto;
//     margin-top: 1%;
//     margin-bottom: 1%;
//   }
//   .list_container {
//     height: ${({ hasCheckinReportAccess }) =>
//       hasCheckinReportAccess ? "320px" : "140px"};
//     margin-top: 5px;
//   }
//   .list_item {
//     width: 100%;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//   }
//   .average {
//     color: blue;
//   }
//   @media ${DEVICE.tablet} {
//     .dash-line {
//       width: 20%;
//       border-bottom: 1px dashed #a8a8a8;
//     }
//     .name-title {
//       display: flex;
//       flex-direction: column;
//       justify-content: space-between;
//       padding-bottom: 15px;
//     }
//     .name-title p {
//       text-align: right;
//       @media (max-width: 321px) {
//         padding-right: 5px;
//       }
//     }
//   }
// `;
// const StyledApprovalSearchForm = styled(Form)`
//   .ant-form-item-with-help {
//     margin-bottom: 0px;
//     .ant-form-item-explain-connected {
//       display: none;
//     }
//   }
//   .ant-form-item {
//     display: inline-block;
//   }
//   .outer-form {
//     margin-right: 0px;
//   }
//   .ant-form-item {
//     margin-bottom: 5px;
//     @media (max-width: 321px) {
//       margin-top: 5px;
//     }
//   }
//   .ant-btn {
//     height: 29px;
//     margin-top: 2px;
//     margin-left: 0px;
//     padding: 0px 10px 2px 10px;
//   }
// `;

// const StyledButton3 = styled(Button)`
//   width: 120px;
//   border: 1px solid ${COLORS.PRIMARY};
//   color: ${COLORS.PRIMARY};
//   width: initial;
//   background: transparent;
//   border-radius: 5px;
//   @media (max-width: 321px) {
//     margin-right: 10px;
//   }
// `;
// const StyleRow = styled(Row)`
//   margin-top: 10px;
// `;
// const StyledSelect = styled(Select)`
//   width: 172px !important;

//   @media (max-width: 320px) {
//     width: 100% !important;
//   }
// `;

// function UserCheckinReport({
//   userInfo,
//   userList,
//   isCheckedIn,
//   ClientId,
//   menuList,
//   userRoleId,
// }) {
//   const [loading, setLoading] = useState(false);
//   const [form] = Form.useForm();
//   const [checkinDetail, setCheckinDetail] = useState([]);
//   const [avg, setAvg] = useState(0);
//   const [ontime, setOntime] = useState(0);
//   const [totalDays, setTotalDays] = useState(0);
//   const [monthList, setMonthList] = useState([]);
//   const Menulist = menuList[userRoleId] || Object.values(menuList)[0];
//   const hasCheckinReportAccess = Menulist?.find(
//     (item) => item?.key === "Punchinout"
//   )?.access;
//   console.log("hasCheckinReportAccess-->", hasCheckinReportAccess);
//   const [CSVcheckinList, setCSVcheckinList] = useState([]);
//   const csvLinkEl = useRef();
//   const shiftStartTime = result(
//     find(userList, { user_id: userInfo?.employer_id, role_id: 4 }),
//     "shift_start_time"
//   );

//   const CSVHeaders = [{ label: "Date" }, { label: "Check-in time" }];

//   const curr_month = moment().month() + 1;

//   const list = () => {
//     let month_list = [];
//     for (let i = 0; i < curr_month; i++) {
//       month_list.push(MONTH_LIST[i]);
//     }
//     setMonthList(month_list);
//   };
//   useEffect(() => {
//     list();
//     getCheckinList();
//   }, [isCheckedIn, ClientId]);

//   const getCheckinList = async () => {
//     return new Promise(async (resolve, reject) => {
//       const {
//         // start_date,
//         duration_type,
//         month,
//         // end_date,
//       } = form.getFieldsValue();

//       const start_date = form.getFieldValue("start_date");
//       const end_date = form.getFieldValue("end_date");
//       const { startDateOfMonth, lastDateOfMonth } = getMonthDateRange(
//         dateInDetail(getKenyanDateTime()).year,
//         get(
//           find(MONTH_LIST, { value: form.getFieldValue("month") }),
//           "index",
//           0
//         )
//       );
//       setLoading(true);
//       if (ClientId) {
//         const { checkInDetail } = await CALL_API(
//           `user-login-details/${ClientId}`,
//           "post",
//           {
//             start_date: getMySqlDate(
//               duration_type === 2
//                 ? startDateOfMonth
//                 : duration_type === 4
//                 ? momentDate(addMonthinDate(getinitialdate()))
//                 : start_date
//             ),
//             end_date: getMySqlDate(
//               duration_type === 2
//                 ? lastDateOfMonth
//                 : duration_type === 3
//                 ? weeks(7, getMySqlDate(start_date))
//                 : duration_type === 4
//                 ? momentDate(addMonthinDate(getKenyanDateTime(), 3))
//                 : end_date
//             ),
//           }
//         );
//         if (checkInDetail) {
//           const sortedCheckinDetails = checkInDetail.flat().sort((a, b) => {
//             const dateA = new Date(a.checkindate);
//             const dateB = new Date(b.checkindate);
//             return dateA - dateB;
//           });
//           setCheckinDetail(sortedCheckinDetails);
//           let total = checkInDetail.length;
//           const ontimeCheckins = filter(checkInDetail, {
//             punchinstatus: "ontime",
//           }).length;
//           // map(checkIn.checkInDetail, (item) =>{
//           //     if (moment(item.checkintime).format('HH:mm') < '08:15'){
//           //     ontimeCount ++
//           //     }
//           // })
//           setTotalDays(total);
//           setOntime(ontimeCheckins);
//           let average = Math.floor((ontimeCheckins * 100) / total);
//           setAvg(average ? average : 0);
//         }

//         setLoading(false);
//       }
//     });
//   };

//   const validateDateRange = (date) => {
//     const initialdate = getinitialdate();
//     const endDate = moment(form.getFieldValue("end_date"));
//     if (endDate < date) {
//       form.setFieldsValue({ end_date: date });
//     }
//     getCheckinList();
//   };

//   function weeks(days, date) {
//     var date = new Date(date);
//     date.setDate(date.getDate() + days);
//     return date.toISOString().slice(0, 10);
//   }

//   const containerRef = useRef(null);

//   const prepareCSV = async (event, done) => {
//     if (checkinDetail.length > 0) {
//       setCSVcheckinList(
//         reduce(
//           checkinDetail,
//           function (result, record) {
//             console.log("checkinDetail-->", checkinDetail);
//             result.push({
//               Date: `${moment(record?.checkindate).format("Do MMM YYYY")}`,
//               Day: `${moment(record?.checkindate).format("dddd")}`,
//               "Check-in time": `${moment(
//                 record?.checkintime,
//                 "HH:mm:ss"
//               ).format("hh:mm A")}`,
//             });
//             return result;
//           },
//           []
//         )
//       );

//       setTimeout(() => {
//         csvLinkEl.current.link.click();
//       });
//     } else {
//       message.error(`No data available to download.`);
//     }
//   };

//   return (
//     <>
//       <StyledChartContainer hasCheckinReportAccess={hasCheckinReportAccess}>
//         <StyledTitle>Check-in Report</StyledTitle>
//         <div className="name-title">
//           <Col
//             xs={5}
//             sm={19}
//             md={19}
//             className="page-title-head"
//             ref={containerRef}
//           >
//             <Space>
//               <StyledApprovalSearchForm
//                 form={form}
//                 name="approval_form"
//                 layout="inline"
//                 onChange={getCheckinList}
//                 initialValues={{
//                   duration_type: 2,
//                   month: dateInDetail(getKenyanDateTime()).monthName,
//                   start_date: momentDate(
//                     addMonthinDate(getKenyanDateTime(), -1)
//                   ),
//                   end_date: momentDate(addDaysinDate(getKenyanDateTime())),
//                 }}
//                 onFinish={getCheckinList}
//               >
//                 <Form.Item
//                   name="duration_type"
//                   rules={[
//                     {
//                       required: true,
//                       message: "",
//                     },
//                   ]}
//                 >
//                   <StyledSelect
//                     placeholder="Select..."
//                     options={CHECKIN_REPORT_FILTER_TYPES}
//                     onChange={getCheckinList}
//                     getPopupContainer={() => containerRef.current}
//                   />
//                 </Form.Item>

//                 <Form.Item className="outer-form" shouldUpdate>
//                   {({ getFieldValue }) => {
//                     const duration_type = getFieldValue("duration_type");
//                     return duration_type === 1 ? (
//                       <>
//                         <Row>
//                           <Col>
//                             <Form.Item
//                               name="start_date"
//                               rules={[
//                                 () => ({
//                                   validator(rule, value) {
//                                     const date = moment(value);
//                                     return date.isValid()
//                                       ? Promise.resolve()
//                                       : Promise.reject();
//                                   },
//                                 }),
//                               ]}
//                               ref={containerRef}
//                             >
//                               <DatePicker
//                                 style={{
//                                   width: 140,
//                                 }}
//                                 placeholder="Start date"
//                                 format="DD-MM-YYYY"
//                                 // disabledDate={(current) => restrictPastDate(current, 'start_date')}
//                                 onChange={validateDateRange}
//                                 allowClear={false}
//                                 getPopupContainer={() => containerRef.current}
//                               />
//                             </Form.Item>
//                           </Col>
//                           <Col>
//                             <Form.Item
//                               name="end_date"
//                               rules={[
//                                 () => ({
//                                   validator(rule, value) {
//                                     const date = moment(value);
//                                     return date.isValid()
//                                       ? Promise.resolve()
//                                       : Promise.reject();
//                                   },
//                                 }),
//                               ]}
//                               ref={containerRef}
//                             >
//                               <DatePicker
//                                 style={{
//                                   width: 140,
//                                 }}
//                                 format="DD-MM-YYYY"
//                                 placeholder="End date"
//                                 onChange={validateDateRange}
//                                 allowClear={false}
//                                 getPopupContainer={() => containerRef.current}
//                                 // disabled={isViewOnly}
//                               />
//                             </Form.Item>
//                           </Col>
//                         </Row>
//                       </>
//                     ) : duration_type === 3 ? (
//                       <Form.Item
//                         name="start_date"
//                         rules={[
//                           () => ({
//                             validator(rule, value) {
//                               const date = moment(value);
//                               return date.isValid()
//                                 ? Promise.resolve()
//                                 : Promise.reject();
//                             },
//                           }),
//                         ]}
//                         ref={containerRef}
//                       >
//                         <DatePicker
//                           style={{
//                             width: 172,
//                           }}
//                           placeholder="Start date"
//                           format="DD-MM-YYYY"
//                           onChange={validateDateRange}
//                           allowClear={false}
//                           getPopupContainer={() => containerRef.current}
//                         />
//                       </Form.Item>
//                     ) : duration_type === 2 ? (
//                       <Form.Item
//                         name="month"
//                         rules={[
//                           {
//                             required: true,
//                             message: "",
//                           },
//                         ]}
//                       >
//                         <StyledSelect
//                           placeholder="Select..."
//                           options={monthList}
//                           onChange={getCheckinList}
//                           getPopupContainer={() => containerRef.current}
//                         />
//                       </Form.Item>
//                     ) : (
//                       ""
//                     );
//                   }}
//                 </Form.Item>
//               </StyledApprovalSearchForm>
//             </Space>
//           </Col>
//         </div>
//         <p className="m-0 p-0 px-2">
//           Average on-time report <span style={{ color: "blue" }}>{avg}%</span>
//         </p>
//         <Spin spinning={loading}>
//           {/* <Col md={24} sm={24} xs={24} xl={24}>
//             <Tooltip
//               placement="bottom"
//               title={`${ontime}/${totalDays} days on-time`}
//             >
//               <Progress
//                 percent={avg}
//                 strokeColor={"#A33CFC"}
//                 trailColor={"#D5A5FF"}
//                 strokeWidth={15}
//                 showInfo={false}
//               />
//             </Tooltip>
//           </Col> */}
//           <div>
//             <StyleRow>
//               <Col md={12} sm={12} xs={24} lg={12} xl={12} className="title">
//                 <h6>Check-in Time</h6>
//               </Col>
//               <Col xs={24} sm={12} md={12} className="align-right">
//                 <ButtonOutlined
//                   onClick={prepareCSV}
//                   disabled={checkinDetail?.length === (0 || null || undefined)}
//                 >
//                   Export CSV
//                 </ButtonOutlined>
//                 <CSVLink
//                   header={CSVHeaders}
//                   data={CSVcheckinList}
//                   filename={"check-in report.csv"}
//                   asyncOnClick={true}
//                   ref={csvLinkEl}
//                 />
//               </Col>
//             </StyleRow>
//             <Col md={24} sm={24} xs={24} xl={24} className="list_container">
//               <List
//                 size="small"
//                 bordered={false}
//                 dataSource={checkinDetail}
//                 renderItem={(item) => (
//                   <List.Item className="list-item border-0">
//                     {moment(item.checkindate).format("DD-MM-YYYY")}
//                     <span className="dash-line" />
//                     {moment(item.checkintime, "HH:mm:ss").format("hh:mm A")}
//                   </List.Item>
//                 )}
//                 style={{
//                   height: "100%",
//                   overflow: "auto",
//                   marginTopBottom: "1%",
//                   border: "none",
//                 }}
//               />
//             </Col>
//           </div>
//         </Spin>
//       </StyledChartContainer>
//     </>
//   );
// }

// const mapStateToProps = (state) => ({
//   userInfo: getUserInfo(state),
//   userList: getUserList(state),
//   isCheckedIn: getIsCheckedIn(state),
//   ClientId: getClientid(state),
//   menuList: getMenuList(state),
//   userRoleId: getUserRoleId(state),
// });

// export default connect(mapStateToProps)(UserCheckinReport);


import React, { useEffect, useState, useRef } from "react";
import { Line } from "@ant-design/plots";
import styled from "@emotion/styled";
import COLORS from "common/Colors";
import { Spin, Progress, List, Tag, Button as AntButton } from "antd";
import {
  CheckCircleFilled,
  ExclamationCircleFilled,
  SyncOutlined,
  WarningFilled,
} from "@ant-design/icons";
import { get, find, map, size, filter, reduce, result, isEmpty } from "lodash";
import {
  MONTH_LIST,
  CHECKIN_REPORT_FILTER_TYPES,
  STATUS_CODE,
  PUNCH_ACTIONS,
  CHECKIN_SYNC_STATUS,
} from "common/Constants";
import {
  addDaysinDate,
  dateInDetail,
  getMonthDateRange,
  getKenyanDateTime,
  addMonthinDate,
  getMySqlDate,
  momentDate,
  getinitialdate,
} from "utils/Date";
import {
  Row,
  Col,
  Table,
  Select,
  DatePicker,
  Space,
  Form,
  Tooltip,
  Modal,
  message,
  Button,
} from "antd";
import moment from "moment";
import { DEVICE } from "common/Device";
import { padding } from "@mui/system";
import { CALL_API } from "common/API";
import { CSVLink } from "react-csv";
import {
  getUserInfo,
  getUserList,
  getIsCheckedIn,
  getClientid,
  getMenuList,
  getUserRoleId,
  getCheckinSyncQueue,  getIsConfirmingCheckIn, 
} from "redux/selectors";
import { connect } from "react-redux";
import { ButtonOutlined } from "reusableComponent/UIButtons";
import { syncNow } from "utils/checkInSyncManager";

const StyledTitle = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: #141414;
  margin-bottom: 10px;
`;

const StyledChartContainer = styled.div`
  // min-height: 280px;
  padding: 20px;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
  border-radius: 5px;
  // margin-bottom: 25px;
  height: 100%;

  .list-item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media (max-width: 426px) {
      font-size: 10px;
    }
  }
  .name-title {
    font-size: 14px;
    padding-bottom: 15px;
  }
  .dash-line {
    width: 60%;
    border-bottom: 1px dashed #a8a8a8;
    @media (max-width: 321px) {
      width: 2%;
    }
  }
  .title {
    padding: 10px;
    font-weight: bold;
  }
  .report_list {
    height: calc(100% - 20px);
    overflow: auto;
    margin-top: 1%;
    margin-bottom: 1%;
  }
  .list_container {
    height: ${({ hasCheckinReportAccess }) =>
      hasCheckinReportAccess ? "320px" : "140px"};
    margin-top: 5px;
  }
  .list_item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .average {
    color: blue;
  }
  @media ${DEVICE.tablet} {
    .dash-line {
      width: 20%;
      border-bottom: 1px dashed #a8a8a8;
    }
    .name-title {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-bottom: 15px;
    }
    .name-title p {
      text-align: right;
      @media (max-width: 321px) {
        padding-right: 5px;
      }
    }
  }
`;
const StyledApprovalSearchForm = styled(Form)`
  .ant-form-item-with-help {
    margin-bottom: 0px;
    .ant-form-item-explain-connected {
      display: none;
    }
  }
  .ant-form-item {
    display: inline-block;
  }
  .outer-form {
    margin-right: 0px;
  }
  .ant-form-item {
    margin-bottom: 5px;
    @media (max-width: 321px) {
      margin-top: 5px;
    }
  }
  .ant-btn {
    height: 29px;
    margin-top: 2px;
    margin-left: 0px;
    padding: 0px 10px 2px 10px;
  }
`;

const StyledButton3 = styled(Button)`
  width: 120px;
  border: 1px solid ${COLORS.PRIMARY};
  color: ${COLORS.PRIMARY};
  width: initial;
  background: transparent;
  border-radius: 5px;
  @media (max-width: 321px) {
    margin-right: 10px;
  }
`;
const StyleRow = styled(Row)`
  margin-top: 10px;
`;
const StyledSelect = styled(Select)`
  width: 172px !important;

  @media (max-width: 320px) {
    width: 100% !important;
  }
`;

const StyledSyncSummary = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  padding: 6px 12px;
  margin-bottom: 10px;
  background: #f5f5f5;
  border-radius: 8px;
  .summary-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #262626;
    .anticon {
      font-size: 15px;
    }
  }
  .synced .anticon {
    color: #1f9d3f;
  }
  .failed .anticon {
    color: #c62828;
  }
  @media (max-width: 426px) {
    gap: 10px;
    .summary-pill {
      font-size: 12px;
    }
  }
`;

const StyledPendingDot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f5a623;
  box-shadow: 0 0 0 3px #fde3b0;
  margin: 0 3px;
`;

const SYNC_BADGE_CONFIG = {
  SYNCED: {
    label: "Synced",
    background: "#eaf7ec",
    borderColor: "#6cc47f",
    textColor: "#1e7b34",
    leadingDot: "#1f9d3f",
  },
  PENDING: {
    label: "Pending (Local)",
    background: "#fff8e6",
    borderColor: "#f3c55b",
    textColor: "#a86b00",
    trailingIcon: <StyledPendingDot />,
  },
  SYNCING: {
    label: "Syncing…",
    background: "#eaf1ff",
    borderColor: "#8aaef0",
    textColor: "#2f5ed6",
    icon: <SyncOutlined spin />,
  },
  FAILED: {
    label: "Sync Failed",
    background: "#fdecec",
    borderColor: "#e57373",
    textColor: "#c62828",
    icon: <WarningFilled />,
  },
};

const StyledSyncBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 12px;
  border-radius: 999px;
  border: 1px solid ${({ bc }) => bc};
  background: ${({ bg }) => bg};
  color: ${({ tc }) => tc};
  font-size: 13px;
  line-height: 20px;
  white-space: nowrap;
  .leading-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ dot }) => dot};
  }
  .anticon {
    font-size: 13px;
  }
  @media (max-width: 426px) {
    font-size: 11px;
    padding: 1px 8px;
  }
`;

const StyledSyncNowButton = styled(AntButton)`
  border-radius: 4px;
  font-size: 12px;
  height: 28px;
  padding: 0 14px;
  background: #3f72c9;
  border-color: #3f72c9;
  color: #fff;
  &:hover,
  &:focus {
    background: #335fad;
    border-color: #335fad;
    color: #fff;
  }
  @media (max-width: 426px) {
    font-size: 11px;
    height: 24px;
    padding: 0 8px;
  }
`;

const StyledCheckinTable = styled.div`
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  overflow: auto;
  max-height: ${({ hasCheckinReportAccess }) =>
    hasCheckinReportAccess ? "320px" : "140px"};
  margin-top: 5px;

  .checkin-grid-row {
    display: grid;
    grid-template-columns:
      minmax(90px, 1fr) minmax(80px, 1fr) minmax(130px, 1.4fr)
      minmax(90px, auto);
    align-items: center;
    column-gap: 12px;
    padding: 10px 16px;
    border-bottom: 1px solid #ececec;
    font-size: 14px;
    color: #262626;
  }
  .checkin-grid-row:last-child {
    border-bottom: none;
  }
  .checkin-grid-head {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #f5f6f8;
    font-weight: 600;
  }
  .checkin-action {
    text-align: right;
  }
  .checkin-empty {
    padding: 20px;
    text-align: center;
    color: #8c8c8c;
  }
  @media (max-width: 426px) {
    .checkin-grid-row {
      grid-template-columns: 1fr 0.9fr 1.3fr auto;
      column-gap: 6px;
      padding: 8px 10px;
      font-size: 11px;
    }
  }
`;

function UserCheckinReport({
  userInfo,
  userList,
  isCheckedIn,
  ClientId,
  menuList,
  userRoleId,
  syncQueue,
    isConfirmingCheckIn, 
}) {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [checkinDetail, setCheckinDetail] = useState([]);
  const [avg, setAvg] = useState(0);
  const [ontime, setOntime] = useState(0);
  const [totalDays, setTotalDays] = useState(0);
  const [monthList, setMonthList] = useState([]);
  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];
  const hasCheckinReportAccess = Menulist?.find(
    (item) => item?.key === "Punchinout"
  )?.access;
  console.log("hasCheckinReportAccess-->", hasCheckinReportAccess);
  const [CSVcheckinList, setCSVcheckinList] = useState([]);
  const csvLinkEl = useRef();
  const shiftStartTime = result(
    find(userList, { user_id: userInfo?.employer_id, role_id: 4 }),
    "shift_start_time"
  );

  const CSVHeaders = [{ label: "Date" }, { label: "Check-in time" }];

  const curr_month = moment().month() + 1;

  const list = () => {
    let month_list = [];
    for (let i = 0; i < curr_month; i++) {
      month_list.push(MONTH_LIST[i]);
    }
    setMonthList(month_list);
  };
  useEffect(() => {
    list();
    getCheckinList();
  }, [isCheckedIn, ClientId]);

  // Once a locally-queued check-in finally reaches the server, pull the
  // canonical record in so the local placeholder row can be dropped.
  const syncedCount = syncQueue?.filter(
    (item) => item.status === CHECKIN_SYNC_STATUS.SYNCED
  ).length;
  useEffect(() => {
    if (syncedCount) getCheckinList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [syncedCount]);

  const getCheckinList = async () => {
    return new Promise(async (resolve, reject) => {
      const {
        // start_date,
        duration_type,
        month,
        // end_date,
      } = form.getFieldsValue();

      const start_date = form.getFieldValue("start_date");
      const end_date = form.getFieldValue("end_date");
      const { startDateOfMonth, lastDateOfMonth } = getMonthDateRange(
        dateInDetail(getKenyanDateTime()).year,
        get(
          find(MONTH_LIST, { value: form.getFieldValue("month") }),
          "index",
          0
        )
      );
      setLoading(true);
      if (ClientId) {
        const { checkInDetail } = await CALL_API(
          `user-login-details/${ClientId}`,
          "post",
          {
            start_date: getMySqlDate(
              duration_type === 2
                ? startDateOfMonth
                : duration_type === 4
                ? momentDate(addMonthinDate(getinitialdate()))
                : start_date
            ),
            end_date: getMySqlDate(
              duration_type === 2
                ? lastDateOfMonth
                : duration_type === 3
                ? weeks(7, getMySqlDate(start_date))
                : duration_type === 4
                ? momentDate(addMonthinDate(getKenyanDateTime(), 3))
                : end_date
            ),
          }
        );
        if (checkInDetail) {
          const sortedCheckinDetails = checkInDetail.flat().sort((a, b) => {
            const dateA = new Date(a.checkindate);
            const dateB = new Date(b.checkindate);
            return dateA - dateB;
          });
          setCheckinDetail(sortedCheckinDetails);
          let total = checkInDetail.length;
          const ontimeCheckins = filter(checkInDetail, {
            punchinstatus: "ontime",
          }).length;
          // map(checkIn.checkInDetail, (item) =>{
          //     if (moment(item.checkintime).format('HH:mm') < '08:15'){
          //     ontimeCount ++
          //     }
          // })
          setTotalDays(total);
          setOntime(ontimeCheckins);
          let average = Math.floor((ontimeCheckins * 100) / total);
          setAvg(average ? average : 0);
        }

        setLoading(false);
      }
    });
  };

  const validateDateRange = (date) => {
    const initialdate = getinitialdate();
    const endDate = moment(form.getFieldValue("end_date"));
    if (endDate < date) {
      form.setFieldsValue({ end_date: date });
    }
    getCheckinList();
  };

  function weeks(days, date) {
    var date = new Date(date);
    date.setDate(date.getDate() + days);
    return date.toISOString().slice(0, 10);
  }

  const containerRef = useRef(null);

  const prepareCSV = async (event, done) => {
    if (checkinDetail.length > 0) {
      setCSVcheckinList(
        reduce(
          checkinDetail,
          function (result, record) {
            console.log("checkinDetail-->", checkinDetail);
            result.push({
              Date: `${moment(record?.checkindate).format("Do MMM YYYY")}`,
              Day: `${moment(record?.checkindate).format("dddd")}`,
              "Check-in time": `${moment(
                record?.checkintime,
                "HH:mm:ss"
              ).format("hh:mm A")}`,
            });
            return result;
          },
          []
        )
      );

      setTimeout(() => {
        csvLinkEl.current.link.click();
      });
    } else {
      message.error(`No data available to download.`);
    }
  };

  // --- Offline / low-bandwidth check-in sync (WAX671O-5501) ---
  // Merge the backend-confirmed check-ins with anything still sitting in
  // the local background-sync queue, so a check-in shows up in this list
  // the instant the user taps the button — not once the network catches up.
  const serverDatesSet = new Set(
    (checkinDetail || []).map((row) =>
      moment(row.checkindate).format("YYYY-MM-DD")
    )
  );

  const localCheckinRows = (syncQueue || [])
    .filter((item) => item.action === PUNCH_ACTIONS.PUNCH_IN)
    .filter((item) => {
      const itemDate = moment(item.createdAt).format("YYYY-MM-DD");
      // Once the server has confirmed this date's check-in, prefer the
      // canonical server row (it'll be in checkinDetail) over the local one.
      return (
        item.status !== CHECKIN_SYNC_STATUS.SYNCED ||
        !serverDatesSet.has(itemDate)
      );
    })
    .map((item) => ({
      key: `local-${item.id}`,
      checkindate: item.createdAt,
      checkintime: moment(item.createdAt).format("HH:mm:ss"),
      syncStatus: item.status,
      syncId: item.id,
      lastError: item.lastError,
      isLocal: true,
    }));

  const serverCheckinRows = (checkinDetail || []).map((row, idx) => ({
    key: `server-${row.checkindate}-${idx}`,
    ...row,
    syncStatus: CHECKIN_SYNC_STATUS.SYNCED,
    isLocal: false,
  }));

  const mergedCheckinRows = [...serverCheckinRows, ...localCheckinRows].sort(
    (a, b) => new Date(a.checkindate) - new Date(b.checkindate)
  );

  const syncCounts = mergedCheckinRows.reduce(
    (acc, row) => {
      if (row.syncStatus === CHECKIN_SYNC_STATUS.FAILED) acc.failed += 1;
      else if (
        row.syncStatus === CHECKIN_SYNC_STATUS.PENDING ||
        row.syncStatus === CHECKIN_SYNC_STATUS.SYNCING
      )
        acc.pending += 1;
      else acc.synced += 1;
      return acc;
    },
    { synced: 0, pending: 0, failed: 0 }
  );

  const handleSyncNow = (syncId) => {
    syncNow(syncId);
  };

  const renderSyncBadge = (row) => {
    const config =
      SYNC_BADGE_CONFIG[row.syncStatus] || SYNC_BADGE_CONFIG.SYNCED;
    const badge = (
      <StyledSyncBadge
        bg={config.background}
        bc={config.borderColor}
        tc={config.textColor}
        dot={config.leadingDot}
      >
        {config.leadingDot && <span className="leading-dot" />}
        {config.icon}
        {config.label}
        {config.trailingIcon}
      </StyledSyncBadge>
    );
    return row.lastError ? (
      <Tooltip title={row.lastError}>{badge}</Tooltip>
    ) : (
      badge
    );
  };

  return (
    <>
      <StyledChartContainer hasCheckinReportAccess={hasCheckinReportAccess}>
        <Row justify="space-between" align="middle" wrap>
          <Col>
            <StyledTitle>Check-in Report</StyledTitle>
          </Col>
          {mergedCheckinRows.length > 0 && (
            <Col>
              <StyledSyncSummary>
                <span className="summary-pill synced">
                  <CheckCircleFilled /> Synced {syncCounts.synced}
                </span>
                <span className="summary-pill pending">
                  <StyledPendingDot /> Pending {syncCounts.pending}
                </span>
                <span className="summary-pill failed">
                  <ExclamationCircleFilled /> Failed {syncCounts.failed}
                </span>
              </StyledSyncSummary>
            </Col>
          )}
        </Row>
        <div className="name-title">
          <Col
            xs={5}
            sm={19}
            md={19}
            className="page-title-head"
            ref={containerRef}
          >
            <Space>
              <StyledApprovalSearchForm
                form={form}
                name="approval_form"
                layout="inline"
                onChange={getCheckinList}
                initialValues={{
                  duration_type: 2,
                  month: dateInDetail(getKenyanDateTime()).monthName,
                  start_date: momentDate(
                    addMonthinDate(getKenyanDateTime(), -1)
                  ),
                  end_date: momentDate(addDaysinDate(getKenyanDateTime())),
                }}
                onFinish={getCheckinList}
              >
                <Form.Item
                  name="duration_type"
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                  ]}
                >
                  <StyledSelect
                    placeholder="Select..."
                    options={CHECKIN_REPORT_FILTER_TYPES}
                    onChange={getCheckinList}
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>

                <Form.Item className="outer-form" shouldUpdate>
                  {({ getFieldValue }) => {
                    const duration_type = getFieldValue("duration_type");
                    return duration_type === 1 ? (
                      <>
                        <Row>
                          <Col>
                            <Form.Item
                              name="start_date"
                              rules={[
                                () => ({
                                  validator(rule, value) {
                                    const date = moment(value);
                                    return date.isValid()
                                      ? Promise.resolve()
                                      : Promise.reject();
                                  },
                                }),
                              ]}
                              ref={containerRef}
                            >
                              <DatePicker
                                style={{
                                  width: 140,
                                }}
                                placeholder="Start date"
                                format="DD-MM-YYYY"
                                // disabledDate={(current) => restrictPastDate(current, 'start_date')}
                                onChange={validateDateRange}
                                allowClear={false}
                                getPopupContainer={() => containerRef.current}
                              />
                            </Form.Item>
                          </Col>
                          <Col>
                            <Form.Item
                              name="end_date"
                              rules={[
                                () => ({
                                  validator(rule, value) {
                                    const date = moment(value);
                                    return date.isValid()
                                      ? Promise.resolve()
                                      : Promise.reject();
                                  },
                                }),
                              ]}
                              ref={containerRef}
                            >
                              <DatePicker
                                style={{
                                  width: 140,
                                }}
                                format="DD-MM-YYYY"
                                placeholder="End date"
                                onChange={validateDateRange}
                                allowClear={false}
                                getPopupContainer={() => containerRef.current}
                                // disabled={isViewOnly}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    ) : duration_type === 3 ? (
                      <Form.Item
                        name="start_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                        ref={containerRef}
                      >
                        <DatePicker
                          style={{
                            width: 172,
                          }}
                          placeholder="Start date"
                          format="DD-MM-YYYY"
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    ) : duration_type === 2 ? (
                      <Form.Item
                        name="month"
                        rules={[
                          {
                            required: true,
                            message: "",
                          },
                        ]}
                      >
                        <StyledSelect
                          placeholder="Select..."
                          options={monthList}
                          onChange={getCheckinList}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    ) : (
                      ""
                    );
                  }}
                </Form.Item>
              </StyledApprovalSearchForm>
            </Space>
          </Col>
        </div>
        <p className="m-0 p-0 px-2">
          Average on-time report <span style={{ color: "blue" }}>{avg}%</span>
        </p>
        <Spin spinning={loading}>
          {/* <Col md={24} sm={24} xs={24} xl={24}>
            <Tooltip
              placement="bottom"
              title={`${ontime}/${totalDays} days on-time`}
            >
              <Progress
                percent={avg}
                strokeColor={"#A33CFC"}
                trailColor={"#D5A5FF"}
                strokeWidth={15}
                showInfo={false}
              />
            </Tooltip>
          </Col> */}
          <div>
            <StyleRow>
              <Col md={12} sm={12} xs={24} lg={12} xl={12} className="title">
                <h6>Check-in Time</h6>
              </Col>
              <Col xs={24} sm={12} md={12} className="align-right">
                <ButtonOutlined
                  onClick={prepareCSV}
                  disabled={checkinDetail?.length === (0 || null || undefined)}
                >
                  Export CSV
                </ButtonOutlined>
                <CSVLink
                  header={CSVHeaders}
                  data={CSVcheckinList}
                  filename={"check-in report.csv"}
                  asyncOnClick={true}
                  ref={csvLinkEl}
                />
              </Col>
            </StyleRow>
            {/* {isConfirmingCheckIn && (
  <Col md={24} sm={24} xs={24} xl={24}>
    <StyledSyncBadge bg="#e6f0ff" tc="#2f5ed6">
      <SyncOutlined spin /> Confirming your location…
    </StyledSyncBadge>
  </Col>
)} */}

            <StyledCheckinTable hasCheckinReportAccess={hasCheckinReportAccess}>
              <div className="checkin-grid-row checkin-grid-head">
                <span>Date</span>
                <span>Time</span>
                <span>Sync Status</span>
                <span />
              </div>
              {mergedCheckinRows.length === 0 ? (
                <div className="checkin-empty">No check-ins found</div>
              ) : (
                mergedCheckinRows.map((item) => (
                  <div className="checkin-grid-row" key={item.key}>
                    <span>{moment(item.checkindate).format("DD-MM-YYYY")}</span>
                    <span>
                      {moment(item.checkintime, "HH:mm:ss").format("hh:mm A")}
                    </span>
                    <span>{renderSyncBadge(item)}</span>
                    <span className="checkin-action">
                      {item.isLocal &&
                        (item.syncStatus === CHECKIN_SYNC_STATUS.PENDING ||
                          item.syncStatus === CHECKIN_SYNC_STATUS.FAILED) && (
                          <StyledSyncNowButton
                            onClick={() => handleSyncNow(item.syncId)}
                          >
                            Sync Now
                          </StyledSyncNowButton>
                        )}
                    </span>
                  </div>
                ))
              )}
            </StyledCheckinTable>
          </div>
        </Spin>
      </StyledChartContainer>
    </>
  );
}

const mapStateToProps = (state) => ({
  userInfo: getUserInfo(state),
  userList: getUserList(state),
  isCheckedIn: getIsCheckedIn(state),
  ClientId: getClientid(state),
  menuList: getMenuList(state),
  userRoleId: getUserRoleId(state),
  syncQueue: getCheckinSyncQueue(state),
    isConfirmingCheckIn: getIsConfirmingCheckIn(state), 
});

export default connect(mapStateToProps)(UserCheckinReport);
